import { render } from "./GuiideDb.vue?vue&type=template&id=a854acba&ts=true"
import script from "./GuiideDb.vue?vue&type=script&lang=ts"
export * from "./GuiideDb.vue?vue&type=script&lang=ts"

import "./GuiideDb.vue?vue&type=style&index=0&id=a854acba&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__